import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Package, ClipboardList, Newspaper, MessageSquareQuote } from "lucide-react";
import { api } from "@/lib/api";

const useCount = (key, endpoint) =>
  useQuery({
    queryKey: [key, "count"],
    queryFn: async () => (await api.get(endpoint)).data.length,
  });

export const AdminDashboard = () => {
  const { data: orderCount } = useCount("orders", "/orders");
  const { data: productCount } = useCount("products", "/products");
  const { data: articleCount } = useCount("articles-admin", "/articles");
  const { data: testimonialCount } = useCount("testimonials", "/testimonials");

  const cards = [
    { label: "Pesanan Masuk", value: orderCount, to: "/admin/pesanan", icon: ClipboardList },
    { label: "Produk", value: productCount, to: "/admin/produk", icon: Package },
    { label: "Artikel", value: articleCount, to: "/admin/artikel", icon: Newspaper },
    { label: "Testimoni", value: testimonialCount, to: "/admin/testimoni", icon: MessageSquareQuote },
  ];

  return (
    <div>
      <h1 className="font-display text-3xl text-ink tracking-tight mb-1">Ringkasan</h1>
      <p className="text-stone2 text-sm mb-8">Selamat datang kembali di panel admin Samsi Madu.</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {cards.map((c) => (
          <Link
            key={c.label}
            to={c.to}
            className="rounded-2xl bg-white border border-border/60 p-6 hover:border-honey hover:shadow-[0_12px_40px_rgba(217,119,6,0.10)] transition-all duration-300"
          >
            <c.icon className="text-honey-dark mb-4" size={24} />
            <div className="text-3xl font-display text-ink">{c.value ?? "—"}</div>
            <div className="text-sm text-stone2 mt-1">{c.label}</div>
          </Link>
        ))}
      </div>
    </div>
  );
};
